export const TRO_READING = 'tro_reading';
export const TRO_PAGE_RECORDING = 'tro_page_recording';
export const TRO_RECORDING = 'tro_recording';
export const TRO_COMPREHENSION_SECTION = 'tro_comprehension_section';
export const QUESTION = 'question';
export const TRO_PRE_ASSESSMENT_STEPS = 'tro_pre_assessment_steps';

export const MAZE_PASSAGE_DURATION = 'maze_passage_duration';
